import { mountFrontend } from './ui/screens';

const root = document.getElementById('app');
if (root) {
  mountFrontend(root);
}
